module.exports = __webpack_public_path__ + "img/capture1.5c463114.png";